const translation = {
  title: 'Testiranje pridobivanja',
  settingTitle: 'Nastavitve pridobivanja',
  desc: 'Preizkusite učinkovitost zadetkov znanja na podlagi podanega poizvedbenega besedila',
  dateTimeFormat: 'DD/MM/YYYY hh:mm A',
  recents: 'Nedavno',
  table: {
    header: {
      source: 'Vir',
      text: 'Besedilo',
      time: 'Čas',
    },
  },
  input: {
    title: 'Izvorno besedilo',
    placeholder: 'Prosimo, vnesite besedilo, priporočljivo je kratko izjavno poved.',
    countWarning: 'Do 200 znakov.',
    indexWarning: 'Samo znanje visoke kakovosti.',
    testing: 'Testiranje',
  },
  hit: {
    title: 'PRIDOBLJENI ODSTAVKI',
    emptyTip: 'Rezultati testiranja pridobivanja bodo prikazani tukaj',
  },
  noRecentTip: 'Tukaj ni nedavnih rezultatov poizvedb',
  viewChart: 'Prikaži VEKTORSKI GRAF',
  viewDetail: 'Prikaži podrobnosti',
  records: 'Zapisov',
  keyword: 'Ključne besede',
  chunkDetail: 'Detajl koščka',
  open: 'Odprt',
  hitChunks: 'Zadenite {{num}} podrejene koščke',
}

export default translation
